import React, { Fragment } from 'react';
import { Segment, Header, Button, Table, Checkbox, Popup, Icon, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema studenata u ovoj grupi.</p>;


export default class StudentsWithGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: [],
            filterData: [],
            results: [],

            // isThisButtonLoading: false,

            showFiltersOnButton: false,
            showFilterMode: null,
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.removeFromGroup = this.removeFromGroup.bind(this);

        this.getDataToRender = this.getDataToRender.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getResults = this.getResults.bind(this);

    }


    onSelectRow(studentCourseCourseImplementationId) {
        const row = this.getDataToRender().find(el => el.studentCourseCourseImplementationId === studentCourseCourseImplementationId);
        const pos = this.state.selectedData.findIndex(el => el.studentCourseCourseImplementationId === row.studentCourseCourseImplementationId);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.studentCourseCourseImplementationId !== row.studentCourseCourseImplementationId);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.getDataToRender().length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.getDataToRender() });
        }
    }

    removeFromGroup() {
        if (!this.state.selectedData.length) {
            toast('Niste odabrali nijednog studenta!');
            return;
        }
        let list = [];
        this.state.selectedData.map(el => {
            list.push(el.studentCourseCourseImplementationId);
        });

        // console.log(this)
        // console.log(this.handleButtonLoadingChange)
        this.props.handleButtonLoadingChange("remove");
        // this.setState({isThisButtonLoading : true})

        axios.delete('course/groups/remove-students', { data: list })
            .then(res => {
                this.setState({ selectedData: [] /*,isThisButtonLoading : false */});
                this.props.getStudents();
                this.props.handleButtonLoadingChange(true);
                this.filtersOff();
                toast('Uklanjanje iz grupe je uspješno izvršeno.');
            })
            .catch(err => {
                toast('Došlo je do greške! Uklanjanje iz grupe nije uspješno izvršeno!');
                this.props.handleButtonLoadingChange(true);
                // this.setState({isThisButtonLoading : false})
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.showFiltersOnButton) {
            return this.state.filterData.sort((a, b) => b.lastName < a.lastName);
        }
        return this.props.data.sort((a, b) => b.lastName < a.lastName);
    }

    getFilterData(studyProgramBasicId, studyProgramId, studyTypeList, firstName, lastName, indexNumber) {
        let docFilter = {};
        if (studyProgramBasicId) docFilter = { ...docFilter, studyProgramBasicId };
        if (studyProgramId) docFilter = { ...docFilter, studyProgramId };
        if (studyTypeList) docFilter = { ...docFilter, studyTypeList };
        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (indexNumber) docFilter = { ...docFilter, indexNumber };

        if (this.state.showFilterMode) {
            if (studyProgramBasicId || studyTypeList || firstName || lastName || indexNumber) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast('Morate unijeti po čemu želite filtrirati podatke!');
            }
        }
        axios.post(`course/groups/students/${this.props.courseImplementationGroupId}/${localStorage.getItem('groupType')}/true`, { ...docFilter })
            .then(res => {
                const filterData = res.data;
                this.setState({ filterData });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.props.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    getResults(results) {
        this.setState({ results });
    }

    render() {
        const { selectedData } = this.state;
        return (
            <div>
                <Divider horizontal>
                    <Header as="h3">Studenti u grupi<br />
                    </Header>
                </Divider>
                <Fragment style={{ backgroundColor: 'white' }}>
                    {!this.props.loadingButton && <Header style={IconHeader} floated="right" >
                        {this.state.showFiltersOnButton && !this.props.loadingButton && <Button
                            onClick={this.filtersOff}
                            floated="left"
                            icon
                            labelPosition="right"
                            color="orange"
                            size="small"
                            style={FiltersOnStyle}
                        >
                            <Icon className="remove" onClick={this.filtersOff} />
                            Filtriranje uključeno!
                        </Button>}
                        <Icon />
                        <Popup
                            trigger={<Icon link circular basic="true" floated="right" name="filter" onClick={this.activateFilter} />}
                            content="Filtriranje podataka"
                            hideOnScroll
                            position="top center"
                        />
                    </Header>}


                    {this.state.showFilterMode && !this.props.loadingButton && <Filters
                        onFilterData={this.getFilterData}
                        filtersOff={this.filtersOff}
                    /> }

                    {this.getDataToRender().length ?
                        <div><Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={this.props.edit ? 14 : 13}>
                                        <SearchTableData disabled={this.props.loadingButton}  profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['lastName', 'firstName', 'indexNumber']} />
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    { (!this.props.archived && this.props.edit) && <Table.HeaderCell width={1}>
                                        <Checkbox
                                            disabled={this.props.loadingButton}
                                            type="checkbox"
                                            name="checkAllButton"
                                            value={selectedData.length === this.getDataToRender().length}
                                            onChange={this.selectAll}
                                            checked={selectedData.length === this.getDataToRender().length}
                                        />
                                    </Table.HeaderCell>}
                                    <Table.HeaderCell colSpan={2} >
                                        R. br.
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={7}>
                                        Prezime i ime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={4}>
                                        Broj indexa
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.getDataToRender().map((el, index) =>
                                (<Table.Row onClick={() => this.onSelectRow(el.studentCourseCourseImplementationId)}>
                                    {(!this.props.archived && this.props.edit) && <Table.Cell verticalAlign="middle">
                                        <Checkbox
                                            disabled={this.props.loadingButton}
                                            name={el.studentCourseCourseImplementationId}
                                            type="checkbox"
                                            checked={selectedData.findIndex(e => e.studentCourseCourseImplementationId === el.studentCourseCourseImplementationId) > -1}
                                        />

                                    </Table.Cell>}
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={7}>
                                        {el.lastName}       {el.firstName}    {el.droppedOutDate !== null ? (
                                            <span style={{ float: 'right', display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                                                <Popup
                                                    content="Ispisan student"
                                                    trigger={<Icon name="sign-out" color="red" />}
                                                    on="hover"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </span>
                                        ) : null}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={4}>
                                        {el.indexNumber}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                            { (!this.props.archived && this.props.edit) && <Button disabled={this.props.loadingButton} loading={this.props.loadingButton === "remove"} color="red" floated="right" onClick={this.removeFromGroup}>
                            Ukloni iz grupe
                            </Button>}
                        </div>
                        : <NoDataMessage />
                    }

                </Fragment>
                {/* <ToastContainer hideProgressBar /> */}
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StudentsWithGroup.js